import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WebtoonCard from "@/components/feature/WebtoonCard";
import { categories } from "@/mocks/categories";
import { webtoons, topRated, featuredList } from "@/mocks/webtoons";

const stats = [
  { value: "1200+", label: "免费作品" },
  { value: "8", label: "精选分类" },
  { value: "每日", label: "榜单更新" },
  { value: "98%", label: "读者好评" },
];

export default function Home() {
  useEffect(() => {
    document.title = "免费韩漫官网-漫糖韩漫|免费韩漫排行榜人气推荐与高分榜单";
  }, []);

  const top = topRated().slice(0, 6);
  const featured = featuredList();
  const newList = [...webtoons].slice(8, 14);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* ===== Hero ===== */}
      <section className="relative flex min-h-[640px] items-center overflow-hidden bg-foreground-950 md:min-h-[680px]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20illustration%20of%20manga%20storyboard%20panels%20with%20floating%20colorful%20drawing%20tools%2C%20books%20and%20glowing%20sparkles%2C%20warm%20coral%20orange%20and%20teal%20and%20gold%20palette%2C%20stylized%20dreamy%20background%2C%20energetic%20creative%20atmosphere%20for%20webtoon%20reading%20platform&width=1800&height=1000&seq=hanman-hero-01&orientation=landscape"
            alt="免费韩漫阅读与排行榜推荐背景图"
            className="h-full w-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>
        </div>

        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-28 text-center md:px-6">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-100 backdrop-blur">
            <i className="ri-fire-fill text-accent-400"></i>
            免费韩漫排行榜 · 每日实时更新人气推荐
          </span>
          <h1 className="mx-auto mt-6 max-w-3xl font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            全网<span className="text-primary-400">免费韩漫</span>
            <br className="hidden md:block" />
            高分人气佳作一网打尽
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-300 md:text-lg">
            从甜宠到悬疑,从奇幻到热血,热门分类全收录。按题材整理的免费韩漫高分榜单,编辑精选口碑佳作,
            帮你快速找到对味的那一部。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/ranking"
              className="flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-trophy-fill"></i>
              查看人气排行榜
            </Link>
            <Link
              to="/category"
              className="flex w-full items-center justify-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-grid-fill"></i>
              浏览热门分类
            </Link>
          </div>

          <div className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-2xl border border-background-50/15 bg-background-50/5 px-4 py-4 backdrop-blur">
                <p className="font-heading text-2xl text-background-50">{s.value}</p>
                <p className="mt-1 text-xs text-background-400">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 热门分类 ===== */}
      <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-grid-fill"></i>
              热门分类
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
              按题材,快速找到你的菜
            </h2>
          </div>
          <Link
            to="/category"
            className="flex items-center gap-1 text-sm text-foreground-600 whitespace-nowrap transition-colors hover:text-primary-600"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group flex flex-col rounded-2xl border border-background-200/70 bg-background-100 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl text-background-50 ${c.color}`}>
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-0.5 text-xs text-foreground-600">{c.en}</p>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{c.tagline}</p>
              <span className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                浏览作品 <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* ===== 实时人气排行榜 ===== */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
            <div>
              <span className="flex items-center gap-1.5 text-sm font-medium text-accent-600">
                <i className="ri-trophy-fill"></i>
                实时人气排行榜
              </span>
              <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
                本周人气 TOP 榜
              </h2>
            </div>
            <Link
              to="/ranking"
              className="flex items-center gap-1 text-sm text-foreground-600 whitespace-nowrap transition-colors hover:text-accent-600"
            >
              查看完整榜单 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="mt-8 space-y-3">
            {top.map((w, i) => (
              <Link
                key={w.id}
                to={`/webtoon/${w.slug}`}
                className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-3 transition-all duration-300 hover:border-accent-200 md:gap-6 md:p-4"
              >
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl font-heading text-xl md:h-14 md:w-14 md:text-2xl ${
                    i === 0
                      ? "bg-accent-500 text-background-50"
                      : i === 1
                      ? "bg-accent-300 text-foreground-900"
                      : i === 2
                      ? "bg-accent-200 text-foreground-800"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {i + 1}
                </span>
                <img
                  src={w.cover}
                  alt={`${w.title} 免费韩漫高分榜单`}
                  title={`${w.title} 人气推荐`}
                  className="hidden h-16 w-12 shrink-0 rounded-lg object-cover object-top sm:block md:h-20 md:w-14"
                />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate text-base font-bold text-foreground-950 md:text-lg">{w.title}</h3>
                    <span className="flex items-center gap-0.5 rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
                      <i className="ri-star-fill text-xs"></i>
                      {w.rating.toFixed(1)}
                    </span>
                  </div>
                  <p className="mt-1 hidden truncate text-sm text-foreground-600 sm:block">{w.shortDesc}</p>
                  <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span>{w.author}</span>
                    <span className="text-background-300">·</span>
                    <span>{w.status}</span>
                    <span className="text-background-300">·</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {w.views}
                    </span>
                  </div>
                </div>
                <i className="ri-arrow-right-s-line text-xl text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-accent-600"></i>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 编辑精选 ===== */}
      <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <span className="flex items-center justify-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-edit-2-fill"></i>
            编辑精选
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">口碑封神的口碑佳作</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            编辑团队反复打磨的高分推荐,从剧情、画风到后劲全面把关,闭眼入都不会踩雷。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {featured.map((w) => (
            <WebtoonCard key={w.id} item={w} />
          ))}
        </div>
      </section>

      {/* ===== 最新上架 ===== */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
            <div>
              <span className="flex items-center gap-1.5 text-sm font-medium text-secondary-600">
                <i className="ri-sparkling-fill"></i>
                新作速递
              </span>
              <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">近期人气新作</h2>
            </div>
            <Link
              to="/category"
              className="flex items-center gap-1 text-sm text-foreground-600 whitespace-nowrap transition-colors hover:text-secondary-600"
            >
              探索更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {newList.map((w) => (
              <WebtoonCard key={w.id} item={w} />
            ))}
          </div>
        </div>
      </section>

      {/* ===== 为什么选择我们 ===== */}
      <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-star-smile-fill"></i>
              关于本站
            </span>
            <h2 className="mt-2 font-heading text-2xl leading-tight text-foreground-950 md:text-4xl">
              你的免费韩漫
              <br />
              高分榜单向导
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              漫糖韩漫致力于把茫茫韩漫海洋里最值得看的作品捞出来给你。我们按题材整理分类,
              实时更新人气推荐与高分榜单,编辑精选口碑佳作,让每个人都能花最少的时间找到对味的那一部。
            </p>
            <div className="mt-6 space-y-3">
              {[
                { icon: "ri-bar-chart-fill", title: "榜单每日更新", desc: "人气与评分数据实时刷新,追更不迷路。" },
                { icon: "ri-archive-fill", title: "题材分类清晰", desc: "甜宠、奇幻、悬疑等八大分类,精准直达。" },
                { icon: "ri-user-heart-fill", title: "编辑口碑把关", desc: "每一部精选都经过反复打磨,闭眼入不踩雷。" },
              ].map((f) => (
                <div key={f.title} className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="text-base font-bold text-foreground-950">{f.title}</h3>
                    <p className="mt-0.5 text-sm text-foreground-600">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20reading%20corner%20with%20smartphone%20showing%20colorful%20webtoon%20pages%2C%20stack%20of%20manga%20books%2C%20soft%20warm%20lighting%2C%20warm%20coral%20and%20teal%20palette%2C%20inviting%20comfortable%20atmosphere%2C%20stylish%20illustration&width=1000&height=1100&seq=hanman-about-01&orientation=portrait"
                alt="免费韩漫阅读推荐与高分榜单平台场景图"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 left-4 flex items-center gap-3 rounded-2xl border border-background-200/70 bg-background-50 px-4 py-3 shadow-card">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                <i className="ri-heart-fill"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">18000+ 读者</p>
                <p className="text-xs text-foreground-600">在这里找到了喜欢的作品</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FAQ teaser ===== */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
          <div className="text-center">
            <span className="flex items-center justify-center gap-1.5 text-sm font-medium text-secondary-600">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">你可能想知道</h2>
          </div>
          <div className="mt-8 space-y-3">
            {[
              ["这里的韩漫真的免费吗?", "漫糖韩漫为您推荐的免费韩漫均来自公开渠道,您可以通过官方或授权渠道免费阅读。"],
              ["排行榜多久更新一次?", "人气排行榜与高分榜单每日实时更新,确保你看到的永远是最新的人气推荐。"],
              ["找不到想看的分类怎么办?", "我们覆盖甜宠、奇幻、剧情、悬疑、校园、恋爱、热血、治愈八大分类,还可以通过搜索快速定位。"],
            ].map(([q, a]) => (
              <details key={q} className="group rounded-2xl border border-background-200/70 bg-background-50 px-5 py-4">
                <summary className="flex cursor-pointer items-center justify-between gap-3 text-base font-bold text-foreground-950">
                  {q}
                  <i className="ri-add-line text-xl text-primary-600 transition-transform group-open:rotate-45"></i>
                </summary>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{a}</p>
              </details>
            ))}
          </div>
          <div className="mt-8 text-center">
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-600 whitespace-nowrap hover:text-secondary-700"
            >
              查看全部常见问题 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-6 py-14 text-center md:px-12 md:py-16">
          <div className="absolute inset-0 opacity-40">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20ink%20splashes%20and%20manga%20halftone%20dots%20in%20coral%20orange%20teal%20and%20gold%2C%20dynamic%20artistic%20background%2C%20vibrant%20creative%20energy%20for%20webtoon%20platform&width=1600&height=600&seq=hanman-cta-01&orientation=landscape"
              alt="免费韩漫榜单人气推荐宣传背景"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 to-foreground-950/80"></div>
          <div className="relative z-10">
            <h2 className="font-heading text-3xl text-background-50 md:text-5xl">今天,想看点什么呢?</h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              从甜宠到悬疑,从奇幻到热血,打开免费韩漫高分榜单,下一秒就遇见对味的作品。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/ranking"
                className="flex w-full items-center justify-center gap-2 rounded-full bg-accent-500 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600 sm:w-auto"
              >
                <i className="ri-fire-fill"></i>
                去逛人气榜单
              </Link>
              <Link
                to="/category"
                className="flex w-full items-center justify-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
              >
                浏览热门分类
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}